<template>
	<span class="relative-time" v-text="timeAgo" />
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue'
import { getTimeAgoShorthand } from '@/helpers/utils'
import { watch } from 'vue'

const props = defineProps({
	date: {
		type: [Date, String],
		required: true,
	},
	interval: {
		type: Number,
		default: 1000,
	},
})
const emit = defineEmits(['tick', 'change'])

const timeAgo = ref(getTimeAgoShorthand(props.date))
const intervalRef = ref(null)

onMounted(() => {
	intervalRef.value = setInterval(() => {
		timeAgo.value = getTimeAgoShorthand(props.date)
		emit('tick', timeAgo.value)
	}, props.interval)
})

onUnmounted(() => {
	clearInterval(intervalRef.value)
})

watch(timeAgo, (newVal) => {
	emit('change', newVal)
})
</script>
